export default "__VITE_ASSET__BR2uC0TT__"